import LegalPage from "@/components/LegalPage";

const sections = [
  {
    h: "What cookies are",
    paras: [
      "Cookies are small text files placed on your device when you visit a website. They are widely used to make websites work securely and efficiently.",
    ],
  },
  {
    h: "How this website uses cookies",
    paras: [
      "This website uses only strictly necessary cookies — those required for the site to function and remain secure, such as cookies that support page routing and security protections.",
      "We do not use analytics, advertising or tracking cookies, and we do not set any non-essential cookies. Because of this, you are not asked to manage cookie preferences when you visit.",
    ],
  },
  {
    h: "Third-party cookies",
    paras: [
      "We do not allow third parties to set cookies through this website for their own purposes, such as advertising or behavioural tracking.",
    ],
  },
  {
    h: "Managing cookies",
    paras: [
      "Most web browsers allow you to control cookies through their settings, including blocking or deleting them. Please be aware that blocking strictly necessary cookies may affect how this website functions.",
    ],
  },
  {
    h: "Changes to this policy",
    paras: [
      "We may update this Cookie Policy from time to time. Any changes will be posted on this page with an updated revision date. If you have questions, contact us at info@kcconsultancy.co.uk.",
    ],
  },
];

export default function Cookies() {
  return (
    <LegalPage
      title="Cookie Policy"
      updated="July 2026"
      sections={sections}
      testid="cookies-page"
    />
  );
}
